/** @format */

import Master from '../Layouts/Master';

const Referee = () => {
	return (
		<Master>
			<div>پنل داوران</div>
		</Master>
	);
};
export default Referee;
